import { useState, useEffect } from 'react';

import Field from 'components/Fields';

const PriceInput = ({ field, error, label }) => {
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    if (field.value === '' || field.value === null) {
      setDisplayValue('');
    } else {
      setDisplayValue((field.value / 100).toString());
    }
  }, [field.value]);

  return (
    <Field
      id="price"
      label={label}
      type="text"
      inputMode="decimal"
      value={displayValue}
      isValid={!error}
      onChange={(e) => {
        const value = e.target.value;

        if (!/^\d*(\.\d{0,2})?$/.test(value)) {
          return;
        }

        setDisplayValue(value);

        if (value === '' || value === '.') {
          field.onChange('');
          return;
        }

        field.onChange(Math.round(Number(value) * 100));
      }}
      onBlur={() => {
        if (displayValue !== '' && displayValue !== '.') {
          setDisplayValue(Number(displayValue).toFixed(2));
        }
      }}
      mb="24px"
    />
  );
};

export default PriceInput;
